import { render, staticRenderFns } from "./VtexProductUpload.vue?vue&type=template&id=16b77a8a&"
import script from "./VtexProductUpload.vue?vue&type=script&lang=js&"
export * from "./VtexProductUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports